import { isValidTimeFormat } from './dates';

export const parseTimeString = (time: string) => {
  return time.split(':');
};

export const applyTimeStringToDate = (date: Date, time: string) => {
  if (!isValidTimeFormat(time)) {
    throw new Error(
      'Invalid time format. Please provide a valid time string in the format "hh:mm".'
    );
  }

  const [hours, minutes] = parseTimeString(time);
  const new_date = new Date(date);

  new_date.setHours(parseInt(hours));
  new_date.setMinutes(parseInt(minutes));

  return new_date;
};
